@if (showGoogleAuth) {
  <div class="social-separator" role="presentation">
    <span class="social-separator__line"></span>
    <span class="social-separator__text">ou</span>
    <span class="social-separator__line"></span>
  </div>

  <div class="google-btn">
    <asl-google-signin-button
      type="standard"
      theme="outline"
      shape="pill"
      text="continue_with"
      size="large"
      logo_alignment="left"
      [width]="280"
    ></asl-google-signin-button>
  </div>
}
